<template>
  <div class="has-text-center center-page-container">
    <div>
      <div class="icon">
        <font-awesome-icon :icon="['fal', 'exclamation-triangle']" size="4x"/>
      </div>
      <h6>
        Your session is expired.
      </h6>
      <span>
        Please
        <router-link to="/login">login</router-link>.
      </span>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faExclamationTriangle,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faExclamationTriangle,
);
export default {
};
</script>

<style lang="sass" scoped>
  .center-page-container
    height: 100%
    position: relative
    margin-top: 10rem
</style>
